import React from "react";

export default function ValentineFrame4({ frameTextToggle, children }) {
  return (
    <svg
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      width="300"
      height="300"
      viewBox="0 0 2000 2000"
    >
      <g transform={frameTextToggle}>
        <defs>
          <style>{".cls4-1{fill:#3a4f7a}.cls4-2{fill:#e98ead}"}</style>
        </defs>
        <g
          id="\u0421\u043B\u043E\u0439_4"
          data-name="\u0421\u043B\u043E\u0439 4"
        >
          <path
            className="cls4-1"
            d="M215 620.5v988.35h1570V620.5Zm905.59 899.66H310.76V710.33h809.83Z"
          />
          <path
            className="cls4-2"
            d="M215 391.15h1570V620.5H215zM1347.39 1160H1304V872.64l-86.92 31.92v-39.15L1340.63 819h6.76ZM1655.68 1046h47.08v35.19h-47.08V1160h-43.34v-78.8h-154.5v-25.4l151.94-235.13h45.9Zm-148.9 0h105.56V879.63l-5.13 9.32ZM1363 1337.25h-70.49v74.19h-22.16v-168h104.08v18.11h-81.92v57.58H1363ZM1495.88 1333.79h-72.8v59.54h84.57v18.11h-106.73v-168h105.57v18.11h-83.41v54.12h72.8ZM1535.22 1411.44v-168h54.92q27.34 0 41.14 11.31t13.78 33.46a34.11 34.11 0 0 1-6.69 20.82 43.31 43.31 0 0 1-18.23 14 39 39 0 0 1 21.52 14.48q7.9 10.68 7.9 25.44 0 22.62-14.65 35.54t-41.42 12.92Zm22.16-96.34h33.46q14.54 0 23.24-7.28t8.72-19.78q0-13.87-8.08-20.17t-24.58-6.31h-32.76Zm0 17.77v60.46H1594q15.46 0 24.4-8t9-22.1q0-30.35-33-30.34Z"
          />
          <circle className="cls4-1" cx={426.62} cy={505.83} r={74.48} />
          <circle className="cls4-1" cx={1572.2} cy={505.83} r={74.48} />
          <path
            className="cls4-2"
            d="M1150.45 1580.59c-39.58-1.48-74.71-8.92-101.59-21.5-27.38-12.82-43.67-29.76-47.12-49-2.72-15.19 1.83-38.09 18.26-52.47 13.61-11.9 33.38-16.26 53.61-12 6.05-19.77 19.41-35 36.4-41.16 20.52-7.45 42.77-.39 54.77 9.33 15.18 12.3 22.15 34.75 20.16 64.91-2 29.61-12.39 64-30.19 99.35l-.6 1.2-2.29 1.33ZM1058.56 1453c-12.55 0-24.1 3.91-32.63 11.38-13.8 12.07-17.62 31.32-15.33 44.1 2.87 16 17.81 31.07 42.08 42.43 25.16 11.78 58.06 18.86 95.29 20.54 16.49-33.41 26.16-65.65 28-93.37 1.76-26.73-4.22-47.09-16.85-57.33-10.09-8.17-28.8-14.12-46-7.86-15.37 5.58-27.29 20.22-31.91 39.16l-1.09 4.48-4.46-1.2a65 65 0 0 0-17.1-2.33Z"
          />
        </g>
        {children}
      </g>
    </svg>
  );
}
